export default __webpack_public_path__ + "static/media/male-young.2d655129.jpg";